export default {
  default: {
    pdv: {
      colorIcon: 'red',
      widthIcon: 45,
      heightIcon: 45,
      anchorIcon: true,
      getGoogleAnchor: (height, width) => new google.maps.Point(width / 2, height),
    },
    pdvConcurent: {
      widthIcon: 30,
      heightIcon: 30,
    }
  }
}
